

// import React, { useEffect } from "react";
// import { Button, DatePicker, Select, Tooltip, Row, Col } from "antd";
// import dayjs from "dayjs";
// import { Typography } from "@mui/material";
// import { chartOptions, dateRanges } from "../../../../Data/data";
 
// const { RangePicker } = DatePicker;
// const { Option } = Select;
 
// const ShipComparisonChartSelector = ({
//   selectedDates,
//   setSelectedDates,
//   engineType,
//   setEngineType,
//   selectedChart,
//   setSelectedChart,
//   selectedParameters,
//   setSelectedParameters,
//   setStartDate,
//   setEndDate,
//   Graph_data,
//   ship_table_list,
//   ship_ids,
//   set_ship_ids,
//   timeFormat,
//   setTimeFormat,
//   engineOptions,
//   parameterMappings,
//   setSelectedLogbook,
//   selectedLogbook,
// }) => {
//   useEffect(() => {
//     if (selectedDates && selectedDates.length === 2) {
//       const startDate = dayjs(selectedDates[0]).format("YYYY-MM-DD");
//       const endDate = dayjs(selectedDates[1]).format("YYYY-MM-DD");
//       setStartDate(startDate);
//       setEndDate(endDate);
//     }
//   }, [selectedDates, setStartDate, setEndDate]);
 
//   useEffect(() => {
//     if (!selectedDates || selectedDates.length === 0) {
//       setSelectedDates([dayjs().subtract(2, "day"), dayjs()]);
//     }
//   }, [selectedDates, setSelectedDates]);
 
//   const handleDateChange = (dates) => setSelectedDates(dates);
 
//   const handleLogbookChange = (value) => {
//     setSelectedLogbook(value);
//     setSelectedParameters([]); // reset parameters on logbook change
//   };
 
//   const handleChartChange = (value) => setSelectedChart(value);
 
//   const handleParameterChange = (values) => {
//     const selected = values.map((v) => {
//       const [shipId, paramValue] = v.split(":");
//       let paramType = null;
//       if (parameterMappings?.[shipId]) {
//         const flatParams = Object.values(parameterMappings[shipId]).flat();
//         const matched = flatParams.find((p) => p.value === paramValue);
//         if (matched) paramType = matched.type || null;
//       }
//       return { shipId, value: paramValue, type: paramType };
//     });
//     setSelectedParameters(selected);
//   };
 
//   return (
//     <div style={{ padding: 10 }}>
//       <Row gutter={[16, 16]}>
//         {/* Ship Selector */}
//         <Col xs={24} sm={12} md={8} lg={6}>
//           <h4>Select Ships</h4>
//           <Select
//             mode="multiple"
//             showSearch
//             placeholder="Select Ships"
//             style={{ width: "100%" }}
//             value={Array.isArray(ship_ids) ? ship_ids : []}
//             onChange={(values) => set_ship_ids(values)}
//             maxTagCount={1}
//             filterOption={(input, option) =>
//               option.children.toLowerCase().includes(input.toLowerCase())
//             }
//           >
//             {ship_table_list
//               ?.filter((ship) => ship.status && !ship.soft_delete)
//               .map((ship) => (
//                 <Option key={ship.id} value={ship.id}>
//                   {ship.vessel_name}
//                 </Option>
//               ))}
//           </Select>
//         </Col>
 
//         {/* Date Range */}
//         <Col xs={24} sm={12} md={8} lg={6}>
//           <h4>Select Date Range</h4>
//           <RangePicker
//             presets={dateRanges}
//             onChange={handleDateChange}
//             value={
//               selectedDates && selectedDates.length
//                 ? [dayjs(selectedDates[0]), dayjs(selectedDates[1])]
//                 : null
//             }
//             format="YYYY-MM-DD"
//             style={{ width: "100%" }}
//             disabledDate={(current) => current && current > dayjs().endOf("day")}
//           />
//         </Col>
 
//         {/* Logbook Selector */}
//         <Col xs={24} sm={12} md={8} lg={6}>
//           <h4>Select Logbook</h4>
//           <Select
//             mode="multiple"
//             showSearch
//             placeholder="Select Logbook Type"
//             maxTagCount={1}
//             onChange={handleLogbookChange}
//             value={selectedLogbook || []}
//             style={{ width: "100%" }}
//           >
//             <Option value="engine_logbook">Engine Logbook</Option>
//             <Option value="deck_logbook">Deck Logbook</Option>
//             <Option value="daily_consumption_log">Daily Consumption Log</Option>
//           </Select>
//         </Col>
 
//         {/* Machinery Selector */}
//         {selectedLogbook.includes("engine_logbook") && (
//           <Col xs={24} sm={12} md={8} lg={6}>
//             <h4>Select Machinery</h4>
//             <Select
//               mode="multiple"
//               placeholder="Select Machinery"
//               value={engineType}
//               onChange={(values) => setEngineType(values)}
//               style={{ width: "100%" }}
//             >
//               {engineOptions.map((shipGroup) => (
//                 <Select.OptGroup key={shipGroup.shipId} label={shipGroup.shipName}>
//                   {shipGroup.options.map((opt) => (
//                     <Option key={opt.value} value={opt.value}>
//                       {opt.label}
//                     </Option>
//                   ))}
//                 </Select.OptGroup>
//               ))}
//             </Select>
//           </Col>
//         )}
 
//         {/* Parameters */}
//         <Col xs={24} sm={12} md={8} lg={6}>
//           <h4>Select Parameters</h4>
//           <Select
//             mode="multiple"
//             showSearch
//             placeholder="Select Parameters"
//             onChange={handleParameterChange}
//             value={selectedParameters?.map((p) => `${p.shipId}:${p.value}`)}
//             style={{ width: "100%" }}
//             maxTagCount={1}
//           >
//             {Object.entries(parameterMappings || {}).map(([shipId, paramGroups]) => {
//               const shipName =
//                 ship_table_list.find((ship) => ship.id == shipId)?.vessel_name ||
//                 `Ship ${shipId}`;
//               const parameters = Object.values(paramGroups || {}).flat();
//               return (
//                 <Select.OptGroup key={shipId} label={shipName}>
//                   {parameters.map((param) => (
//                     <Option
//                       key={`${shipId}-${param.value}`}
//                       value={`${shipId}:${param.value}`}
//                     >
//                       {param.label}
//                     </Option>
//                   ))}
//                 </Select.OptGroup>
//               );
//             })}
//           </Select>
//         </Col>
 
//         {/* Chart Type */}
//         <Col xs={24} sm={12} md={8} lg={6}>
//           <h4>Select Chart Type</h4>
//           <Select
//             showSearch
//             placeholder="Select Chart Type"
//             onChange={handleChartChange}
//             value={selectedChart || undefined}
//             style={{ width: "100%" }}
//           >
//             {chartOptions?.map((chart) => (
//               <Option key={chart.value} value={chart.value}>
//                 {chart.label}
//               </Option>
//             ))}
//           </Select>
//         </Col>
 
//         {/* Time Format */}
//         <Col xs={24} sm={12} md={8} lg={6}>
//           <Typography variant="body2">Time Format</Typography>
//           <Select
//             value={timeFormat}
//             style={{ width: "100%" }}
//             onChange={setTimeFormat}
//             options={[
//               { label: "Daily", value: "daily" },
//               { label: "Weekly", value: "weekly" },
//               { label: "Monthly", value: "monthly" },
//             ]}
//           />
//         </Col>
 
//         {/* Generate Button */}
//         <Col xs={24} sm={12} md={8} lg={6}>
//           <Button
//             type="primary"
//             block
//             style={{
//               marginTop: "18px",
//               backgroundColor: "#E11236",
//               fontWeight: 900,
//             }}
//             onClick={Graph_data}
//           >
//             Generate Graph
//           </Button>
//         </Col>
//       </Row>
//     </div>
//   );
// };
 
// export default ShipComparisonChartSelector;
 




import React, { useEffect } from "react";
import { Button, DatePicker, Select, Tooltip, Row, Col } from "antd";
import dayjs from "dayjs";
import { Typography } from "@mui/material";
import { chartOptions, dateRanges } from "../../../../Data/data";

const { RangePicker } = DatePicker;
const { Option } = Select;

const ShipComparisonChartSelector = ({
  selectedDates,
  setSelectedDates,
  engineType,
  setEngineType,
  selectedChart,
  setSelectedChart,
  selectedParameters,
  setSelectedParameters,
  setStartDate,
  setEndDate,
  Graph_data,
  ship_table_list,
  ship_ids,
  set_ship_ids,
  timeFormat,
  setTimeFormat,
  engineOptions,
  parameterMappings,
  setSelectedLogbook,
  selectedLogbook,
}) => {
  useEffect(() => {
    if (selectedDates && selectedDates.length === 2) {
      const startDate = dayjs(selectedDates[0]).format("YYYY-MM-DD");
      const endDate = dayjs(selectedDates[1]).format("YYYY-MM-DD");
      setStartDate(startDate);
      setEndDate(endDate);
    }
  }, [selectedDates, setStartDate, setEndDate]);

  useEffect(() => {
    if (!selectedDates || selectedDates.length === 0) {
      setSelectedDates([dayjs().subtract(2, "day"), dayjs()]);
    }
  }, [selectedDates, setSelectedDates]);

  const handleDateChange = (dates) => setSelectedDates(dates);

  const handleLogbookChange = (value) => {
    setSelectedLogbook(value);
    setSelectedParameters([]); // reset parameters on logbook change
  };

  const handleChartChange = (value) => setSelectedChart(value);

  // const handleParameterChange = (values) => {
  //   const selected = values.map((v) => {
  //     const [shipId, paramValue] = v.split(":");
  //     let paramType = null;
  //     if (parameterMappings?.[shipId]) {
  //       const flatParams = Object.values(parameterMappings[shipId]).flat();
  //       const matched = flatParams.find((p) => p.value === paramValue);
  //       if (matched) paramType = matched.type || null;
  //     }
  //     return { shipId, value: paramValue, type: paramType };
  //   });
  //   setSelectedParameters(selected);
  // };
  const handleParameterChange = (values) => {
    const selected = values.map((v) => {
      const [shipId, paramValue] = v.split(":");

      let paramType = null;

      if (parameterMappings?.[shipId]) {
        const flatParams = Object.values(parameterMappings[shipId]).flat();
        const matched = flatParams.find((p) => p.value === paramValue);

        if (matched) {
          paramType = matched.type;
        }
      }

      return { shipId, value: paramValue, type: paramType };
    });

    setSelectedParameters(selected);
  };

  return (
    <div style={{ padding: 10 }}>
      <Row gutter={[16, 16]}>
        {/* Ship Selector */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <h4>Select Ships</h4>
          <Select
            mode="multiple"
            showSearch
            placeholder="Select Ships"
            style={{ width: "100%" }}
            value={Array.isArray(ship_ids) ? ship_ids : []}
            onChange={(values) => set_ship_ids(values)}
            maxTagCount={1}
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {ship_table_list
              ?.filter((ship) => ship.status && !ship.soft_delete)
              .map((ship) => (
                <Option key={ship.id} value={ship.id}>
                  {ship.vessel_name}
                </Option>
              ))}
          </Select>
        </Col>

        {/* Date Range */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <h4>Select Date Range</h4>
          <RangePicker
            presets={dateRanges}
            onChange={handleDateChange}
            value={
              selectedDates && selectedDates.length
                ? [dayjs(selectedDates[0]), dayjs(selectedDates[1])]
                : null
            }
            format="YYYY-MM-DD"
            style={{ width: "100%" }}
            disabledDate={(current) =>
              current && current > dayjs().endOf("day")
            }
          />
        </Col>

        {/* Logbook Selector */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <h4>Select Logbook</h4>
          <Select
            mode="multiple"
            showSearch
            placeholder="Select Logbook Type"
            maxTagCount={1}
            onChange={handleLogbookChange}
            value={selectedLogbook || []}
            style={{ width: "100%" }}
          >
            <Option value="engine_logbook">Engine Logbook</Option>
            <Option value="deck_logbook">Deck Logbook</Option>
            <Option value="daily_consumption_log">Daily Consumption Log</Option>
          </Select>
        </Col>

        {/* Machinery Selector */}
        {selectedLogbook.includes("engine_logbook") && (
          <Col xs={24} sm={12} md={8} lg={6}>
            <h4>Select Machinery</h4>
            <Select
              mode="multiple"
              placeholder="Select Machinery"
              value={engineType}
              onChange={(values) => setEngineType(values)}
              style={{ width: "100%" }}
            >
              {engineOptions.map((shipGroup) => (
                <Select.OptGroup
                  key={shipGroup.shipId}
                  label={shipGroup.shipName}
                >
                  {shipGroup.options.map((opt) => (
                    <Option key={opt.value} value={opt.value}>
                      {opt.label}
                    </Option>
                  ))}
                </Select.OptGroup>
              ))}
            </Select>
          </Col>
        )}

        {/* Parameters */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <h4>Select Parameters</h4>
          <Select
            mode="multiple"
            showSearch
            placeholder="Select Parameters"
            onChange={handleParameterChange}
            value={selectedParameters?.map((p) => `${p.shipId}:${p.value}`)}
            style={{ width: "100%" }}
            maxTagCount={1}
          >
            {Object.entries(parameterMappings || {}).map(
              ([shipId, paramGroups]) => {
                const shipName =
                  ship_table_list.find((ship) => ship.id == shipId)
                    ?.vessel_name || `Ship ${shipId}`;

                return (
                  <Select.OptGroup key={shipId} label={shipName}>
                    {Object.values(paramGroups)
                      .flat()
                      .map((param) => (
                        <Option
                          key={`${shipId}-${param.value}`}
                          value={`${shipId}:${param.value}`}
                        >
                          {param.label}
                        </Option>
                      ))}
                  </Select.OptGroup>
                );
              }
            )}
          </Select>
        </Col>

        {/* Chart Type */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <h4>Select Chart Type</h4>
          <Select
            showSearch
            placeholder="Select Chart Type"
            onChange={handleChartChange}
            value={selectedChart || undefined}
            style={{ width: "100%" }}
          >
            {chartOptions?.map((chart) => (
              <Option key={chart.value} value={chart.value}>
                {chart.label}
              </Option>
            ))}
          </Select>
        </Col>

        {/* Time Format */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <Typography variant="body2">Time Format</Typography>
          <Select
            value={timeFormat}
            style={{ width: "100%" }}
            onChange={setTimeFormat}
            options={[
              { label: "Daily", value: "daily" },
              { label: "Weekly", value: "weekly" },
              { label: "Monthly", value: "monthly" },
            ]}
          />
        </Col>

        {/* Generate Button */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <Button
            type="primary"
            block
            style={{
              marginTop: "18px",
              backgroundColor: "#E11236",
              fontWeight: 900,
            }}
            onClick={Graph_data}
          >
            Generate Graph
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default ShipComparisonChartSelector;
